import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  const consequences = [{
    num: '01',
    title: 'Menos reuniones',
    desc: 'Un sitio web que no transmite confianza desde el primer segundo genera menos solicitudes de contacto y reuniones.'
  }, {
    num: '02',
    title: 'Menos cotizaciones',
    desc: 'Un sitio web que no comunica valor reduce la disposición del cliente a solicitar propuestas formales.'
  }, {
    num: '03',
    title: 'Menor credibilidad percibida',
    desc: 'Tu sitio web define si tu empresa es considerada antes de cualquier conversación. Es el primer criterio de evaluación.'
  }, {
    num: '04',
    title: 'Publicidad que no convierte',
    desc: 'Invertir en publicidad sin un sitio web que convierta multiplica el costo de adquisición sin garantía de resultado.'
  }];
  return <section className="bg-arena py-[72px] md:py-[120px]" data-id="element-339">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-340">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24" data-id="element-341">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} data-id="element-342">
            <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-6" data-id="element-343">
              EL PROBLEMA
            </span>

            <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1] mb-4" data-id="element-344">
              La mayoría de las empresas B2B no tiene un problema de publicidad.
            </h2>
            <h2 className="font-display text-[32px] md:text-[48px] font-bold text-verde leading-[1.1] mb-10" data-id="element-345">
              Tiene un sitio web que no comunica lo que vale.
            </h2>

            <p className="font-body text-[16px] md:text-[18px] text-carbon/65 leading-[1.65] max-w-[480px]" data-id="element-346">
              Cuando un cliente potencial entra a tu sitio web y no puede ver
              claramente el valor de lo que ofreces en los primeros tres
              segundos, la decisión más fácil es cerrar la pestaña. O entrar al
              sitio de tu competencia.
            </p>
          </motion.div>

          {/* Right Column */}
          <div className="flex flex-col" data-id="element-347">
            {consequences.map((item, idx) => <motion.div key={idx} className="pb-8 mb-8 border-b border-carbon/10 last:border-0 last:mb-0 last:pb-0" initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.4,
            ease: 'easeOut',
            delay: idx * 0.1
          }} data-id="element-348">
                <span className="block font-body text-[11px] uppercase font-semibold text-carbon/25 mb-3" data-id="element-349">
                  {item.num}
                </span>
                <h3 className="font-display text-[20px] font-semibold text-carbon mb-2" data-id="element-350">
                  {item.title}
                </h3>
                <p className="font-body text-[15px] text-carbon/60 leading-relaxed" data-id="element-351">
                  {item.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}